/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-11-01 14:57:38
 * @LastEditors: Jack Deng
 * @LastEditTime: 2023-03-13 15:15:38
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/AllOrders/OrderDetail/ParcelProcess/Components/PackageDetail/index.tsx
 */
import { get } from 'lodash';
import React from 'react';
import {
  Image,
  ModalFooter,
  OriCheckbox,
  OriNumberInput,
  OriSelect,
  SizeFittingTable,
} from 'src/components/Antd';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import { EnumTablePosition } from 'src/types/common/common';
import { EType } from 'src/types/common/order';
import css from './css.module.less';
//import { isNumber } from 'src/tools/helper';
import { unitSuffix } from '@/src/tools/config';
import { Icon } from '@/src/tools/icon';
import { UnitType } from '@/src/types/common/common';
import { Spin } from 'antd';
import AntdImageDisplay from 'src/components/Upload/ImageDisplay/AntdImageDisplay';
import ModalHoc from 'src/constrains/ModalHOC';
import CustomizationRow from 'src/pages/Order/Components/ExclusiveCustom';
import { getParcel } from 'src/request/order';
import { hasValue } from 'src/tools/helper';
import { accMul } from 'src/tools/math';
import { msg } from 'src/tools/message';
import TakePhoto from './TakePhoto';

import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const { Option } = OriSelect;

export const mockData = [];

const PackageDetail = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const { modalOp, uuid, isPacking, onCancel, onConfirm } = props;
  const [loading, setLoading] = React.useState(true);
  const [images, setImages] = React.useState([]);
  const [d, setD] = React.useState(null);
  const [parcelItems, setParcelItems] = React.useState([]);
  const [needToBeConfirmed, setNeedToBeConfirmed] = React.useState({});
  const [actualWeight, setWeight] = React.useState(null);
  const [actualUnit, setUnit] = React.useState(UnitType.Kilogram);
  //console.log('actualUnit', actualUnit);
  const boxId = get(d, 'suggestedBox.boxId');
  const weight = get(d, 'suggestedBox.weight');
  const weightUnit = get(d, 'suggestedBox.weightUnit');
  const depth = get(d, 'suggestedBox.depth');
  const height = get(d, 'suggestedBox.height');
  const width = get(d, 'suggestedBox.width');
  const dimensionUnit = get(d, 'suggestedBox.dimensionUnit');
  const _dimensionUnit = unitSuffix[dimensionUnit] || '';
  const dimension =
    width && height && depth
      ? `${width} ${_dimensionUnit} x ${height} ${_dimensionUnit} x ${depth} ${_dimensionUnit}`
      : '-';
  const _weight = weight ? `${weight} ${unitSuffix[weightUnit] || ''}` : '-';

  const estimatedWeight = get(d, 'estimatedWeight.weight');
  const estimatedWeightUnit = get(d, 'estimatedWeight.unit');
  const _estimatedWeight = hasValue(estimatedWeight)
    ? `${estimatedWeight} ${unitSuffix[estimatedWeightUnit] || ''}`
    : '-';

  const disableOk =
    isPacking &&
    Object.keys(needToBeConfirmed || {}).filter((i) => !needToBeConfirmed[i])
      .length !== 0;

  const assData = (data) => {
    setD(data);
    const images = get(data, 'images', []);
    setImages(images);
    const parcelItems = get(data, 'parcelItems', []);
    setParcelItems(parcelItems);
    const needToBeConfirmed = parcelItems.reduce((o, item) => {
      const productSetSku = get(item, 'productSetSku');
      const customisation = get(item, 'customisation');
      const customisationIsDone = get(item, 'customisationIsDone');
      const uuid = get(item, 'uuid');
      if (!productSetSku && customisation) {
        return { ...o, [uuid]: customisationIsDone };
      }
      return o;
    }, {});
    setNeedToBeConfirmed(needToBeConfirmed);
    const weight = get(data, 'actualWeight.weight');
    const unit = get(data, 'actualWeight.unit');
    setWeight(weight);
    setUnit(unit);
  };

  React.useEffect(() => {
    getParcel(uuid).then((res) => {
      setLoading(false);
      assData(res);
    });
  }, []);
  //const {}=props

  const { setShowModal, setModalTitle, setModalContent, onModalCancel } =
    modalOp;
  const tableName = 'OrderDetailPackageDetailTable';
  const data = parcelItems;
  const expandedRows = (data || []).map((i) => i.uuid);

  const handleOnConfirm = () => {
    msg.loading({
      content: getI18n(
        'allOrders.orderDetail.components_ClickAndCollectDetail_handleOnConfirm',
      ),
    });
    if (onConfirm) {
      if (isPacking) {
        const customisationHasBeenDone = parcelItems.map((i) => {
          const { uuid } = i;
          return {
            ...i,
            customisationIsDone: needToBeConfirmed[uuid],
          };
        });
        const data = {
          ...d,
          images,
          actualWeight: {
            weight: actualWeight,
            unit: actualUnit,
          },
          parcelItems: customisationHasBeenDone,
        };
        onConfirm(data);
      } else {
        const data = { ...d, images };
        onConfirm(data);
      }
    }
  };

  return (
    <React.Fragment>
      <Spin spinning={loading}>
        <div className={css.container}>
          <div className={css.tableContainer}>
            <SizeFittingTable
              rowKey='uuid'
              scroll={{ y: 430 }}
              pagination={false}
              dataSource={data || []}
              className={css.detailTable}
              id={tableName}
              columns={col({ getI18n })}
              expandable={{
                expandedRowClassName: () => css.expandedRow,
                expandedRowKeys: expandedRows,
                expandIconColumnIndex: -1,
                indentSize: 0,
                expandedRowRender: (record, index) => {
                  //const { customisation } = record;
                  const customisationItem =
                    get(record, 'customisation.items') || [];

                  const uuid = get(record, 'uuid');
                  const productSetSku = get(record, 'productSetSku');
                  const productSetName = get(record, 'productSetName');
                  const customisation = get(record, 'customisation');
                  const hasCustomisation = !!customisation;
                  const isFromSet = !!productSetSku;
                  const tiedCustomizationDisplay = customisationItem.map(
                    (i) => {
                      const { title, values } = i;
                      const content = (values || []).join(',');
                      return { title: `${title}: ${content}` };
                    },
                  );
                  return (
                    <React.Fragment key={index}>
                      {customisation && (
                        <React.Fragment>
                          <div className={css.customizationLine}>
                            <CustomizationRow
                              key={index}
                              data={tiedCustomizationDisplay}
                              //price={'100'}
                            />
                            {/* {customisationItem.map((i, index) => {
                              const { title, values } = i;
                              const content = (values || []).join(',');
                              console.log(title, content);
                              return (
                                <CustomizationRow
                                  key={index}
                                  title={`${title}: ${content}`}
                                  //price={'100'}
                                />
                              );
                            })}{' '} */}
                          </div>
                        </React.Fragment>
                      )}
                      {isFromSet && (
                        <div className={css.customizationConfirmLineSet}>
                          {getI18n(
                            `allOrders.orderDetail.components_ClickAndCollectDetail_return_tableContainer_productset`,
                          )}{' '}
                          {`${productSetName}(${productSetSku})`}
                        </div>
                      )}
                      {isFromSet && hasCustomisation && (
                        <div className={css.customizationConfirmLineSetLast}>
                          {getI18n(
                            `allOrders.orderDetail.components_packagedetail_return_tableContainer_comfirm_service`,
                          )}
                        </div>
                      )}
                      {hasCustomisation && !isFromSet && (
                        <div className={css.customizationConfirmLine}>
                          <OriCheckbox
                            disabled={!isPacking}
                            className={css.checkbox}
                            checked={needToBeConfirmed[uuid]}
                            onChange={(e) => {
                              const checked = e.target.checked;
                              const _needToBeConfirmed = {
                                ...needToBeConfirmed,
                              };
                              _needToBeConfirmed[uuid] = checked;
                              setNeedToBeConfirmed(_needToBeConfirmed);
                              //console.log('checked', checked);
                            }}>
                            {getI18n(
                              `allOrders.orderDetail.components_packagedetail_return_tableContainer_comfirm_customisation`,
                            )}
                          </OriCheckbox>
                        </div>
                      )}
                    </React.Fragment>
                  );
                },
              }}
            />
          </div>
          <div className={css.detailContainer}>
            <div className={css.packageInfo}>
              <div className={css.topPart}>
                <div className={css.sectionTitle}>
                  {getI18n(
                    `allOrders.orderDetail.components_packagedetail_return_topPart_section_title`,
                  )}
                </div>
                <ItemWrapper
                  title={getI18n(
                    `allOrders.orderDetail.components_packagedetail_return_topPart_box_title`,
                  )}>
                  {boxId || '-'}
                </ItemWrapper>
                <ItemWrapper
                  title={getI18n(
                    `allOrders.orderDetail.components_packagedetail_return_topPart_Dimension_title`,
                  )}>
                  {dimension}
                </ItemWrapper>
                <ItemWrapper title={getI18n('general.weight')}>
                  {_weight}
                </ItemWrapper>
              </div>
              <div className={css.lowPart}>
                <ItemWrapper
                  title={getI18n(
                    `allOrders.orderDetail.components_packagedetail_return_lowPart_EstimatedWeight_title`,
                  )}
                  titlePadding16>
                  {_estimatedWeight}
                </ItemWrapper>
                <ItemWrapper
                  title={getI18n(
                    `allOrders.orderDetail.components_packagedetail_return_lowPart_ActualWeight_title`,
                  )}
                  titlePadding16>
                  <div className={css.inputContainer}>
                    <OriNumberInput
                      min={0}
                      max={99999}
                      disabled={!isPacking}
                      placeholder={'0.0'}
                      className={css.numberInput}
                      size='large'
                      value={actualWeight}
                      onChange={setWeight}
                    />
                    <OriSelect
                      disabled={!isPacking}
                      size='large'
                      className={css.select}
                      onChange={setUnit}
                      value={actualUnit}>
                      <Option value={UnitType.Kilogram}>
                        {unitSuffix[UnitType.Kilogram]}
                      </Option>
                      <Option value={UnitType.Gram}>
                        {unitSuffix[UnitType.Gram]}
                      </Option>
                      <Option value={UnitType.Pound}>
                        {unitSuffix[UnitType.Pound]}
                      </Option>
                      <Option value={UnitType.Ounce}>
                        {unitSuffix[UnitType.Ounce]}
                      </Option>
                    </OriSelect>
                  </div>
                </ItemWrapper>
              </div>
            </div>
            <div className={css.photoPart}>
              <div className={css.photoTitle}>
                {getI18n(
                  `allOrders.orderDetail.components_packagedetail_return_photoPart_photo_title`,
                )}
              </div>
              <div className={css.photoContainer}>
                <div
                  className={css.photoPlaceholder}
                  onClick={() => {
                    setModalTitle('');
                    setModalContent(
                      <TakePhoto
                        onCancel={onModalCancel}
                        onSave={(image) => {
                          onModalCancel();
                          const img = [...images, image];
                          setImages(img);
                        }}
                      />,
                    );
                    setShowModal(true);
                  }}>
                  <Icon type='iconhome' />
                </div>
                {images.map((i, index) => {
                  const { url } = i;
                  return (
                    <AntdImageDisplay
                      onRemove={() => {
                        const _images = [...images];
                        _images.splice(index, 1);
                        setImages(_images);
                      }}
                      hasOptionsLayer
                      //preview={false}
                      hideEdit
                      style={{
                        marginBottom: 12,
                      }}
                      width={100}
                      height={100}
                      key={url}
                      src={url}
                      alt={url}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <ModalFooter
          onOk={handleOnConfirm}
          onCancel={onCancel}
          hideOkButton={disableOk}
        />
      </Spin>
    </React.Fragment>
  );
};
export default ModalHoc(PackageDetail, { width: 900 });
const widthDict = {
  item: { minWidth: 180 },
  sku: { width: 140 },
  qty: {
    width: 60,
  },
  paid: { width: 90 },
};
const col = ({ getI18n }) => {
  return [
    {
      title: getI18n(
        `allOrders.orderDetail.components_packagedetail_colreturn_item_title`,
      ),
      key: 'Items (Store)',
      default: true,
      //optional: false,
      //className: css.tableCol,
      childGenerate: (text, record) => {
        // console.log('record', record);
        const { productName } = record;
        const thumbnailUrl = get(record, 'image.url');
        //console.log('thumbnailUrl', thumbnailUrl);
        return (
          <div className={css.productNameContainer}>
            <Image
              style={{
                marginRight: 12,
                minWidth: 40,
              }}
              width={40}
              height={40}
              key={thumbnailUrl}
              src={thumbnailUrl}
              alt={thumbnailUrl}
            />

            <NoWrapContainer>
              <GlobalTooltip zIndex={99999} title={productName || '-'}>
                <div className={css.text}>{productName || '-'}</div>
              </GlobalTooltip>
            </NoWrapContainer>
          </div>
        );
      },
      ...widthDict['item'],
    },
    {
      title: getI18n(
        `allOrders.orderDetail.components_packagedetail_colreturn_sku_title`,
      ),
      key: 'SKU',
      default: true,
      //optional: false,
      //className: css.tableCol,
      childGenerate: (text, record) => {
        // console.log('record', record);
        const { sku } = record;
        return (
          <NoWrapContainer>
            <GlobalTooltip zIndex={99999} title={sku || '-'}>
              {sku}
            </GlobalTooltip>
          </NoWrapContainer>
        );
      },
      ...widthDict['sku'],
    },
    {
      titleGenerate: () => (
        <span>
          {getI18n(
            `allOrders.orderDetail.components_packagedetail_colreturn_qty_title`,
          )}
        </span>
      ),
      key: 'QTY',
      default: true,
      //optional: false,
      //  className: css.tableCol,
      position: EnumTablePosition.right,
      childGenerate: (text, record, index) => {
        // console.log('record', record);
        const { amount } = record;
        return (
          <NoWrapContainer>
            <GlobalTooltip zIndex={99999} title={amount || '-'}>
              {amount}
            </GlobalTooltip>
          </NoWrapContainer>
        );
      },
      ...widthDict['qty'],
    },
    {
      titleGenerate: () => (
        <div>
          {getI18n(
            `allOrders.orderDetail.components_packagedetail_colreturn_price_title`,
          )}
        </div>
      ),
      key: 'Paid',
      default: true,
      //optional: false,
      //  className: css.tableCol,
      position: EnumTablePosition.right,
      childGenerate: (text, record) => {
        // console.log('record', record);
        const { paidPrice, type, amount } = record;
        if (type === EType.Gift) {
          return (
            <span>
              {' '}
              {getI18n(
                `allOrders.orderDetail.components_packagedetail_colreturn_judgeType`,
              )}
            </span>
          );
        }
        const data = accMul(amount, paidPrice).toFixed(2);
        return (
          <NoWrapContainer className={css.paidPrice}>
            <GlobalTooltip zIndex={99999} title={data}>
              {data || '-'}
            </GlobalTooltip>
          </NoWrapContainer>
        );
      },
      ...widthDict['paid'],
    },
  ];
};
const ItemWrapper = (props) => {
  const { title, children, titlePadding16 } = props;
  return (
    <div className={css.itemWrapperContainer}>
      <div
        className={css.itemWrapperTitle}
        style={titlePadding16 ? { marginBottom: 16 } : {}}>
        {title}
      </div>
      {children}
    </div>
  );
};
